import React from "react";
import ReactDOM from "react-dom";
import firebaseApp from '../../firebase';
import FileUploader from "react-firebase-file-uploader";

class MultiFileUpload extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filenames: [],
            downloadURLs: [],
            isUploading: false,
            uploadProgress: 0
        }
        this.handleUploadStart = this.handleUploadStart.bind(this)
        this.handleProgress = this.handleProgress.bind(this)
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this)
        this.handleUploadError = this.handleUploadError.bind(this)
    }

    handleToggleBtns = () => {
        if (this.props.internal) {
            this.props.toggleDisableParentBtn();
        } else {
            this.props.toggleDisableInternalBtn();
        }
    };

    handleUploadStart = () => {
        this.setState({
            isUploading: true,
            uploadProgress: 0
        });
        this.handleToggleBtns();
    };

    handleProgress = progress => {
        this.setState({
            uploadProgress: progress
        });
    };

    handleUploadError = error => {
        this.setState({
            isUploading: false
            // Todo: handle error
        });
        console.error(error);
        this.handleToggleBtns();
    };

    handleUploadSuccess = async filename => {
        console.log(filename);
        const path = this.props.path;
        console.log(`${path}${filename}`);

        const downloadURL = await firebaseApp
        .storage()
        .ref(`${path}`)
        .child(filename)
        .getDownloadURL();

        let urls = {}
        urls['orig'] = downloadURL;
        urls['scaled'] = '';
        urls['thumb'] = '';

        this.setState(oldState => ({
            filenames: [...oldState.filenames, filename],
            downloadURLs: [...oldState.downloadURLs, downloadURL],
            uploadProgress: 100,
            isUploading: false
        }));
        this.props.callback(urls);
    };

    progressBar = () => {
        if(this.state.uploadProgress > 0){
            return (
                <progress max="100" value={this.state.uploadProgress}></progress>
            ) 
        } else {
            return null
        }
    }

    render() {
        const path = this.props.path;

        return (
            <div>
                {this.progressBar()}
                {/* <p>Progress: {this.state.uploadProgress}</p> */}
                <FileUploader
                accept="image/*"
                name="image-uploader-multiple"
                randomizeFilename
                storageRef={firebaseApp.storage().ref(`${path}`)}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
                multiple
                />
            </div>
        );
    }
}

MultiFileUpload.defaultProps = {
    'name': null,
    'path': 'images/',
    'internal': false,
    'toggleDisableInternalBtn': () => {},
    'toggleDisableParentBtn': () => {},
    'callback': () =>{}
}
  
export default MultiFileUpload;


// WEBPACK FOOTER //
// ./src/components/ui/MultiFileUpload.jsx